module.exports = __webpack_public_path__ + "static/img/ok.de5f6397.png";